export const createModule = (services) => {
  const {
    getPermittedRoutes,
  } = services.user;

  class ApplicationAccess {
    constructor(name, arg, accessRights, accessLevel) {
      this.name = name;
      this.arg = arg;
      this.accessRights = accessRights;
      this.accessLevel = accessLevel;
    }

    isApplicationEqual(app) {
      return this.name === app.name;
      // TODO fix after GraphQL API would be changed to REST API.
      // In another case it would not be possible to edit Customer-1/Sweden/System-2/Verfahren-1/2/3/4 seperatly
      // return this.name === app.name && (this.arg === app.arg || (isNullish(this.arg) && isNullish(app.args))); TODO check .arg (id)
    }
  }

  return {
    namespaced: true,
    state: {
      initializing: false,
      appsAccessByLocation: {},
      routesByLocation: {},
    },

    actions: {
      deinit({
        commit,
      }) {
        commit('reset');
      },
      async init({
        commit,
      }, location) {
        try {
          commit('setInitializing', true);

          const groups = await getPermittedRoutes(location);

          const appsAccess = [];

          const createAppAccess = ({
            routeName,
            id,
            rights,
            accessLevel,
          }) => new ApplicationAccess(routeName, id, rights, accessLevel);

          groups.forEach((group) => {
            group.items.forEach((item) => {
              if (item.routeName) {
                appsAccess.push(createAppAccess(item));
              }
            });
          });
          const routes = groups;

          commit('setRoutes', {
            location,
            routes,
          });
          commit('setAppsAccess', {
            location,
            appsAccess,
          });
        } catch (e) {
          commit('setRoutes', {
            location,
            routes: [],
          });
          commit('setAppsAccess', {
            location,
            appsAccess: [],
          });
          throw e;
        } finally {
          commit('setInitializing', false);
        }
      },
    },

    mutations: {
      reset(state) {
        state.accessListByLocation = {};
        state.routesByLocation = {};
      },
      setAppsAccess(state, {
        location, appsAccess,
      }) {
        state.appsAccessByLocation = {
          ...state.appsAccessByLocation,
          [location]: appsAccess,
        };
      },
      setInitializing(state, flag) {
        state.initializing = flag;
      },
      setRoutes(state, {
        location, routes,
      }) {
        state.routesByLocation = {
          ...state.routesByLocation,
          [location]: routes,
        };
      },
    },

    getters: {
      getRoutes: (state) => (location) => state.routesByLocation[location],
      getPermissions: (state) => (location, application) => {
        const permissions = state.appsAccessByLocation[location]?.find((item) => item.isApplicationEqual(application));
        return (
          permissions
          || new ApplicationAccess(application.name, application.arg, {})
        );
      },
    },
  };
};
